<div class="payment_div_wrapper">
<div class="container">
    <app-booking-steps [travellers]="true" [passengerDetails]="true" [review]="true" [ticket]="true" [payment]="true">
    </app-booking-steps>
    <div class="booking-container" style="padding-bottom: 60px;">
        <div class="nopad">
            <div class="payment_div">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-8 col-sm-8 nopad fulbuki">
                            <h3 _ngcontent-lbw-c186="" class="inpagehed">Payment</h3>
                            <div class="sectionbuk billingnob" style="box-shadow: 0px 1px 16px #ddd;">
                                <div class="col-md-12 col-lg-12 nopad">
                                    <h6 _ngcontent-lbw-c186="" class="paysec">
                                        <div class="cardselect valign-wrapper">
                                            <div class="custom-control custom-radio">
                                                <input type="radio" id="customRadio1" checked="" name="customRadio"
                                                    class="custom-control-input payradio">
                                                <label class="custom-control-label"
                                                    for="customRadio1">Credit/Debit/Wallet</label>
                                            </div>

                                        </div>
                                    </h6>
                                    <div class="clearfix"></div>
                                    <div class="col-md-12">

                                        <div class="col-md-12 col-sm-12 nopad fulbuki">
                                            <div class="wrappay leftboks">
                                                <form [formGroup]="paymentForm">
                                                    <div class="cc-selector-2" *ngIf="isPaymentGatewayEnabled">
                                                        <div class="row">
                                                            <div class="col-md-4 col-4 mobile_pad7" *ngFor="let paymentMethod of paymentGateways">
                                                                <span *ngIf="(paymentMethod?.remarks | lowercase)==='nagad'">
                                                                    <label class="drinkcard-cc nagad" for="nagad"></label>
                                                                    <span class="payment_label">
                                                                        <input id="nagad" type="radio" name="paymentMethod" value="nagad" formControlName="paymentMethod" /> {{paymentMethod?.remarks}}
                                                                    </span>
                                                                </span>
                                                                <span *ngIf="(paymentMethod?.remarks | lowercase)==='bkash'">
                                                                    <label class="drinkcard-cc bKash" for="bKash"></label>
                                                                    <span class="payment_label">
                                                                        <input id="bKash" type="radio" name="paymentMethod" value="bKash" formControlName="paymentMethod" /> {{paymentMethod?.remarks}}
                                                                    </span>
                                                                </span>
                                                                <span *ngIf="(paymentMethod?.remarks | lowercase)==='sslcommerz'">
                                                                    <label style="width: 100%;background-position: center;" class="drinkcard-cc sslCommerz" for="sslCommerz"></label>
                                                                    <span class="payment_label">
                                                                        <input id="sslCommerz" type="radio" name="paymentMethod" value="sslCommerz" formControlName="paymentMethod" />
                                                                        {{paymentMethod?.remarks}}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <small class="error text-danger col-xs-12 col-12"
                                                        style="margin-bottom:10px; display:block;"
                                                        *ngIf="hasError('paymentMethod', 'required');">
                                                        Please select the payment type* <br>
                                                    </small>
                                                </form>
                                                <h6 *ngIf="!isPaymentGatewayEnabled" class="noPaymentGateway">No payment gateways enabled, Please connect to support.</h6>
                                            </div>
                                            <div class="clearfix"></div>
                                            <div class="payrowsubmt row" style="    padding-bottom: 0px;
                                            padding-top: 0px;
                                            border-top: 1px solid #ddd;
                                            padding: 20px;
                                            text-align: center;
                                            margin-top: 20px;" *ngIf="isPaymentGatewayEnabled">
                                                <div class="checkcontent"
                                                    style="overflow: inherit; display: table; margin: 0px auto 15px;">
                                                    <div class="squaredThree"
                                                        style="height: 12px; margin: 2px 4px; float:left;">
                                                        <input type="checkbox" value="0" name="confirm" [checked]="terms"
                                                            class="filter_airline" id="squaredThree2" required
                                                            aria-required="true" (click)="onTerms($event.target.checked)">
                                                        <label for="squaredThree2"></label>
                                                    </div>
                                                    <label for="squaredThree2" class="lbllbl"
                                                        style="display: inline; font-size: 14px;">By
                                                        checking the box, you have read and agreed to the 
                                                        <a (click)="openStaticPage('terms-conditions')" class="colorbl">Terms and Conditions</a>,
                                                        <a (click)="openStaticPage('privacy-policy')" class="colorbl">Privacy Policy</a>
                                                        and <a (click)="openStaticPage('refund-policy')" class="colorbl">Refund Policy</a> of nosafer.
                                                    </label>
                                                </div>
                                                <div class="text-danger" *ngIf="!terms">
                                                    <small> Please accept Terms and
                                                        Conditions/Privacy
                                                        Policy.
                                                    </small>
                                                </div>
                                                <div class="col-md-12 col-sm-12 fulat500 nopad"
                                                    style="width: auto; display: table; margin: 0px;">
                                                    <a class="paysubmit" name="continue" id="continue" value="Continue"
                                                        (click)="paymentConfirm()">
                                                        Confirm
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="col-md-4 col-lg-4 mt-3 padlt">
                            <app-booking-fare-summary [flight]="flight"></app-booking-fare-summary>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
<!-- Payment popup -->
<div class="modal" id="paymentModal" tabindex="-1" role="dialog" aria-labelledby="paymentModalLabel" aria-hidden="true"
    [style.display]="showPaymentDetails ? 'block' : 'none'">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="paymentModalLabel">Payment methods</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="paymentForm">
                    <div class="cc-selector-2">
                        <div class="row">
                            <div class="col-md-4 col-4 mobile_pad7">
                                <label class="drinkcard-cc nagad" for="nagad"></label>
                                <span class="payment_label">
                                    <input id="nagad" type="radio" name="paymentMethod" value="nagad"
                                        formControlName="paymentMethod" />
                                    Nagad
                                </span>
                            </div>
                            <div class="col-md-4 col-4 mobile_pad7">
                                <label class="drinkcard-cc bKash" for="bKash"></label>
                                <span class="payment_label">
                                    <input id="bKash" type="radio" name="paymentMethod" value="bKash"
                                        formControlName="paymentMethod" />
                                    bKash
                                </span>
                            </div>
                            <div class="col-md-4 col-4 mobile_pad7">
                                <label style="width: 100%;" class="drinkcard-cc sslCommerz" for="sslCommerz"></label>
                                <span class="payment_label">
                                    <input id="sslCommerz" type="radio" name="paymentMethod" value="sslCommerz"
                                        formControlName="paymentMethod" /> sslCommerz
                                </span>
                            </div>
                        </div>
                    </div>
                    <small class="error text-danger col-xs-12 col-12" style="margin-bottom:10px; display:block;"
                        *ngIf="hasError('paymentMethod', 'required');">
                        Please select the payment type* <br>
                    </small>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="paysubmit" (click)="paymentConfirm()">Confirm</button>
            </div>
        </div>
    </div>
</div>